const { version } = require('../../package.json')
import { UsersABConfigType } from './ApiClient.types'

type InitProps = {
  mode: string
  industryType: IndustryType
  productType?: ProductType
  useStaticPhones?: boolean
}

type ConfigType = {
  amplitude: {
    sessionId?: number
    deviceId?: string
    userId?: string
  }
  mode: string
  version: string
  platform: string
  framework: string
  url: string
  host: string
  quiz_version: string | null | undefined
  gclid: string | null | undefined
  fbclid: string |null | undefined
  SRC_CD: string | null | undefined
  utm_campaign: string | null | undefined
  utm_source: string | null | undefined
  utm_content: string | null | undefined
  utm_term: string | null | undefined
  utm_medium: string | null | undefined
  utm_program: string | null | undefined
  utm_call: string | null | undefined
  MEDIAALPHA_TOKEN: string | null

  init: (props: InitProps) => void
  setUTMParamsFromURLorCookie: (useStaticPhones?: boolean) => void
  saveUTMParamsToCookies: (useStaticPhones?: boolean) => void
  UTMHash: () => void
  getCookie: (name: string) => string | null | undefined
  setCookie: (name: string, value: string) => void
  setABConfigs: (configs: UsersABConfigType) => void
  getUrlParameterByName: (a: string, b?: string) => string | null
  canUseDOM: boolean

  usePhoneTTY: boolean
  useStaticPhones: boolean
  industryType: IndustryType
  productType: ProductType | null

  abConfigs: UsersABConfigType
}

/* CONFIG
/* ---------------------------------------------------------------------- */
const Config: ConfigType = {
  amplitude: {},
  mode: '',
  fbclid: '',
  version: '',
  platform: '',
  framework: '',
  url: '',
  host: '',
  quiz_version: '',
  gclid: '',
  utm_campaign: '',
  utm_source: '',
  utm_content: '',
  utm_term: '',
  utm_medium: '',
  utm_program: '',
  utm_call: '',
  MEDIAALPHA_TOKEN: '',
  SRC_CD: '',
  usePhoneTTY: false,
  useStaticPhones: false,
  industryType: null,
  productType: null,
  abConfigs: {} as UsersABConfigType,

  /* Initialization */
  /* ------------------------------------------------- */
  init: function({
    mode,
    industryType,
    productType,
    useStaticPhones,
  }: InitProps) {
    this.mode = mode;
    this.version = version;
    this.platform = 'web';
    this.framework = 'ssr';
    this.url = window.location.pathname;
    this.host = window.location.host;
    this.industryType = industryType;
    this.usePhoneTTY = industryType === 'Medsup';
    this.useStaticPhones = !!useStaticPhones;
    this.productType = productType || null;

    console.log(`[Config] mode: ${mode} | version: ${this.version}`);

    this.setUTMParamsFromURLorCookie(useStaticPhones);
    this.saveUTMParamsToCookies(useStaticPhones);
  },

  /* UTM Tracking */
  /* ------------------------------------------------- */
  setUTMParamsFromURLorCookie: function(useStaticPhones?: boolean) {
    this.gclid = this.getUrlParameterByName('gclid');
    this.fbclid = this.getCookie('_fbc') || this.getUrlParameterByName('fbclid');
    this.SRC_CD = this.getUrlParameterByName('SRC_CD');
    this.utm_campaign = this.getUrlParameterByName('utm_campaign') || this.getCookie('hiqCookie-utm_campaign');
    this.utm_source = this.getUrlParameterByName('utm_source') || this.getCookie('hiqCookie-utm_source');
    this.utm_content = this.getUrlParameterByName('utm_content') || this.getCookie('hiqCookie-utm_content');
    this.utm_term = this.getUrlParameterByName('utm_term') || this.getCookie('hiqCookie-utm_term');
    this.utm_medium = this.getUrlParameterByName('utm_medium') || this.getCookie('hiqCookie-utm_medium');
    this.utm_program = this.getUrlParameterByName('utm_program') || this.getCookie('hiqCookie-utm_program');
    this.utm_call = this.getUrlParameterByName('utm_call');
    if (!useStaticPhones && !this.utm_call) {
      // Cookie value not used on home page for utm_call (only if set by url).
      this.utm_call = this.getCookie('hiqCookie-utm_call');
    }

    if (this.utm_source === 'mediaalpha') {
      this.MEDIAALPHA_TOKEN = this.getUrlParameterByName('token');
    }

    if (this.url === '/life-insurance/lifemart') {
      this.utm_source = 'lifemart';
    }
  },

  saveUTMParamsToCookies: function(useStaticPhones?: boolean) {
    if (this.utm_campaign && this.utm_campaign !== '') {
      this.setCookie('hiqCookie-utm_campaign', this.utm_campaign);
    }
    if (this.utm_source && this.utm_source !== '') {
      this.setCookie('hiqCookie-utm_source', this.utm_source);
    }
    if (this.utm_content && this.utm_content !== '') {
      this.setCookie('hiqCookie-utm_content', this.utm_content);
    }
    if (this.utm_term && this.utm_term !== '') {
      this.setCookie('hiqCookie-utm_term', this.utm_term);
    }
    if (this.utm_medium && this.utm_medium !== '') {
      this.setCookie('hiqCookie-utm_medium', this.utm_medium);
    }
    if (this.utm_program && this.utm_program !== '') {
      this.setCookie('hiqCookie-utm_program', this.utm_program);
    }
    if (!useStaticPhones && this.utm_call && this.utm_call !== '') {
      this.setCookie('hiqCookie-utm_call', this.utm_call);
    }
  },

  UTMHash: function() {
    var utmParams: Record<any, any> = {}
    if (Config.utm_campaign && Config.utm_campaign !== '') {
      utmParams.utm_campaign = Config.utm_campaign;
    }
    if (Config.utm_source && Config.utm_source !== '') {
      utmParams.utm_source = Config.utm_source;
    }
    if (Config.utm_content && Config.utm_content !== '') {
      utmParams.utm_content = Config.utm_content;
    }
    if (Config.utm_term && Config.utm_term !== '') {
      utmParams.utm_term = Config.utm_term;
    }
    if (Config.utm_medium && Config.utm_medium !== '') {
      utmParams.utm_medium = Config.utm_medium;
    }
    if (Config.utm_program && Config.utm_program !== '') {
      utmParams.utm_program = Config.utm_program;
    }
    if (Config.utm_call && Config.utm_call !== '') {
      utmParams.utm_call = Config.utm_call;
    }
    return utmParams
  },

  /* Cookies */
  /* ------------------------------------------------- */
  getCookie: function(name: string) {
    if (typeof document === 'undefined') {
      return null;
    }

    name = name + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
  },

  setCookie: function(name: string, value: string) {
    document.cookie = name + '=' + value + ';domain=.healthiq.com;path=/';
  },

  setABConfigs: function(configs: UsersABConfigType) {
    this.abConfigs = configs
  },

  /* Helpers */
  /* ------------------------------------------------- */
  getUrlParameterByName: function(a: string, b?: string) {b||(b=window.location.href),a=a.replace(/[\[\]]/g,"\\$&");var c=new RegExp("[?&]"+a+"(=([^&#]*)|&|#|$)"),d=c.exec(b);return d?d[2]?decodeURIComponent(d[2].replace(/\+/g," ")):"":null},

  canUseDOM: !!(typeof window !== 'undefined' &&
      window.document && window.document.createElement)
}

export default Config;
